import AMapLoader from "@amap/amap-jsapi-loader";
import wgs84togcj02N from '@/utils/wgs';
import positionIcon from '@/assets/images/monitor/icon_dingweizhi@2x.png';
const __sfc_main = {};
__sfc_main.props = {
  info: {
    type: Object,
    default: () => {
      return {
        longitude: '',
        latitude: ''
      };
    }
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    proxy
  } = getCurrentInstance();
  const emit = __ctx.emit;
  const props = __props;

  // 地图
  let map, AMap;
  onMounted(() => {
    AMapLoader.load({
      key: proxy.amapKey,
      version: "2.0"
    }).then(amap => {
      AMap = amap;
      map = new AMap.Map("map", {
        zoom: 12
      });
      if (!props.info.longitude || !props.info.latitude) return;
      const lnglat = wgs84togcj02N(props.info.longitude, props.info.latitude);
      // 位置icon
      const icon = new AMap.Icon({
        image: positionIcon,
        size: new AMap.Size(50, 50)
      });
      const marker = new AMap.Marker({
        position: lnglat,
        zIndex: 150,
        offset: new AMap.Pixel(-25, -25),
        icon: icon
      });
      map.add(marker);
      map.setFitView(null, true);
    });
  });
  onBeforeUnmount(() => {
    map.destroy();
  });
  return {};
};
export default __sfc_main;